import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ColumnFilterRow, SortableHeaderRow, TableToolbar, useTableTools } from "@/components/TableFilters";
import api, { fmtMXN, fmtDate } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

const STATUS_COLOR = { aceptada: "bg-blue-100 text-blue-700", surtido: "bg-amber-100 text-amber-700", enviado: "bg-indigo-100 text-indigo-700", cerrado: "bg-emerald-100 text-emerald-700" };

const OSTATUS = [["aceptada", "Aceptada"], ["surtido", "Surtido"], ["enviado", "Enviado"], ["cerrado", "Cerrado"]];
const OPAGO = [["pendiente", "Pendiente"], ["parcial", "Parcial"], ["pagado", "Pagado"]];
const COLUMNS = [
  { key: "folio", label: "Folio", accessor: (o) => o.folio, placeholder: "Folio" },
  { key: "po", label: "P.O. Cliente", accessor: (o) => o.po_number, placeholder: "P.O." },
  { key: "cliente", label: "Cliente", accessor: (o) => o.client_snapshot?.razon_social, placeholder: "Cliente" },
  { key: "total", label: "Total", accessor: (o) => o.total, placeholder: "Total" },
  { key: "estatus", label: "Estatus", type: "select", accessor: (o) => o.estatus, options: OSTATUS.map(([value, label]) => ({ value, label })) },
  { key: "pago", label: "Pago", type: "select", accessor: (o) => o.pago_estatus, options: OPAGO.map(([value, label]) => ({ value, label })) },
  { key: "vence", label: "Vence", accessor: (o) => fmtDate(o.fecha_vencimiento), sortAccessor: (o) => o.fecha_vencimiento, placeholder: "Vence" },
];

export default function Orders() {
  const [rows, setRows] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/orders").then((r) => setRows(r.data)); }, []);
  const tools = useTableTools(rows, COLUMNS);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div><h1 className="text-3xl font-heading font-bold tracking-tight">Pedidos</h1><p className="text-muted-foreground text-sm">Órdenes de pedido, logística y cobranza.</p></div>
        <TableToolbar tools={tools} columns={COLUMNS} filename="pedidos" />
      </div>
      <Card className="rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <SortableHeaderRow columns={COLUMNS} sort={tools.sort} toggleSort={tools.toggleSort} />
            {tools.showFilters && <ColumnFilterRow columns={COLUMNS} filters={tools.filters} setFilters={tools.setFilters} />}
          </TableHeader>
          <TableBody>
            {tools.view.map((o) => (
              <TableRow key={o.id} className="cursor-pointer" onClick={() => nav(`/app/pedidos/${o.id}`)} data-testid="order-row">
                <TableCell className="font-mono font-medium">{o.folio}</TableCell>
                <TableCell className="font-mono text-xs">{o.po_number}</TableCell>
                <TableCell>{o.client_snapshot?.razon_social}</TableCell>
                <TableCell>{fmtMXN(o.total)}</TableCell>
                <TableCell><span className={`px-2 py-1 rounded text-xs font-medium ${STATUS_COLOR[o.estatus]}`}>{o.estatus}</span></TableCell>
                <TableCell><Badge variant={o.pago_estatus === "pagado" ? "default" : "secondary"}>{o.pago_estatus}</Badge></TableCell>
                <TableCell className={o.vencido ? "text-red-500 font-medium" : "text-muted-foreground"}>{fmtDate(o.fecha_vencimiento)}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-8">Sin pedidos aún.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
